import Vue from 'vue'
import moment from 'moment'
import { Base64 } from 'js-base64'

const filters = {
  base64IMG(val) {
    if (val) {
      return Base64.decode(val)
    } else {
      return ''
    }
  },
  formatDate(val, mode = 'YYYY-MM-DD HH:mm:ss') {
    return val ? moment(Number(val)).format(mode) : ''
  },
  money(val, mode = 100) {
    return val ? val / mode : 0
  },
  content(val) {
    return `您的${val.certName}将于${moment(Number(val.deadlineDate)).format(
      'YYYY年MM月DD日'
    )}到期，请及时处理！`
  },
  // 过滤币种
  moneyCurr(val) {
    if (val) {
      if (val == 1) {
        return '￥'
      } else {
        return '$'
      }
    }
  },
  formatData(val) {
    val = String(val)
    var len = val.length
    // console.log(len);
    var xing = ''
    for (var i = 0; i < len - 6; i++) {
      xing += '*'
    }
    return val.substr(0, 3) + xing + val.substr(len - 3, len)
  }
}

for (let key in filters) {
  Vue.filter(key, filters[key])
}
